function initData () {
  return {
    values: {
      reloadReport: '',
      reloadAccount: '',
      loading: false,
      password: '',
      lendings: [],
    },
  }
}

export const state = () => initData()

export const mutations = {
  PUT (state, obj) {
    for (const key in obj) {
      state.values[key] = obj[key]
    }
  },
}

export const getters = {
  GET_STRING (state) {
    return key => state.values[key] || ''
  },
  GET_BOOLEAN (state) {
    return key => state.values[key] || false
  },
}
